var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrritantsDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z",
    id: "path-1-irritants-dis"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-426.000000, -315.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Toxins/Inactive/Irritants",
    transform: "translate(428.000000, 317.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/36px/Toxins/Inactive/Cancerogens"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1-irritants-dis"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "#000000",
    xlinkHref: "#path-1-irritants-dis"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M18,37 C7.50658975,37 -1,28.4934102 -1,18 C-1,7.50658975 7.50658975,-1 18,-1 C28.4934102,-1 37,7.50658975 37,18 C37,28.4934102 28.4934102,37 18,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.0672554348,
    stroke: "#979797",
    strokeWidth: 1,
    d: "M18,35.5 C27.6649831,35.5 35.5,27.6649831 35.5,18 C35.5,8.33501688 27.6649831,0.5 18,0.5 C8.33501688,0.5 0.5,8.33501688 0.5,18 C0.5,27.6649831 8.33501688,35.5 18,35.5 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(9.000000, 4.000000)",
    fill: "#C4C4C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.997,12 C12.375,11.36 13.81,9.502 13.997,8 C14.795,9.054 17.997,13 17.997,16 C17.997,23 11.581,24.889 10.997,25 C11.289,24.43 11.997,23.365 11.997,22 C11.997,20.647 11.834,20.658 10.997,19 C10.213,17.446 8.997,15 8.997,15 L6.996,19.012 C6.373,20.261 5.987,20.852 5.997,22 C6.006,23.027 6.306,24.011 6.997,25 C6.534,24.842 0,23 0,15.979 C0,13.378 1.14,11.475 2.878,9.495 C3.903,8.326 4.958,7.158 5.997,6 C8.692,2.996 8.616,1.71 8.997,0 C10.966,2.468 11.997,4.792 11.997,7 C11.997,9 11.452,10.636 10.997,12",
    id: "Fill-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrritantsDisabled);
export default __webpack_public_path__ + "static/media/IrritantsDisabled.e643e4f597af996148ad5f2bd40afc22.svg";
export { ForwardRef as ReactComponent };